<template>
  <div>
    <div class="mobile__footer_block_button"v-if="!isVisibilityModal" @click="modalAction">
      <p class="mobile__footer_block_button_p">{{button}}</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "MarketButtonMobile",
  data: () => ({
    button: ''
 }),
  methods: {
    buttonUpdate() {
      this.button = this.marketplaces.btn_text
    },
    modalAction(){
      this.$store.dispatch('modalAction', true)
      document.body.classList.toggle('fix');
    }
  },
  computed: {
    ...mapGetters(['marketplaces','MarketItems']),
    isVisibilityModal() {
      return this.$store.state.button.isVisibilityModal
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchMarketplaces')
    await this.$store.dispatch('fetchLand')
    this.$nextTick(this.buttonUpdate)
  }
}
</script>